import React, { FC } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { useTheme } from "emotion-theming";
import { StandardTheme } from "@nectarTypes";
import { SpinnerContainer } from "./style";

type SpinnerLoadingProps = {
  css?: React.CSSProperties;
  color?: string;
  size?: number;
  containerStyle?: React.CSSProperties;
};

const SpinnerLoading: FC<SpinnerLoadingProps> = ({ css, color, size, containerStyle }) => {
  const theme = useTheme<StandardTheme>();
  const useColor = theme.colors[color] ?? theme.colors.primary500;

  return (
    <SpinnerContainer style={containerStyle}>
      <ClipLoader size={size} color={useColor} cssOverride={css} />
    </SpinnerContainer>
  );
};

export default SpinnerLoading;
